export enum TagType {
    sports = 'sports',
    product = 'product',
}
